import React from 'react';
import {
    LineChart, Line, BarChart, Bar,
    PieChart, Pie, Cell,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

export const MonthlyTrendsChart = ({ chartData }) => (
    <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '24px', color: '#0f172a' }}>Monthly Purchase, Sale, Expense & Payment Line Chart</h3>
        <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
                <XAxis dataKey="month" tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} tickFormatter={(v) => `${(v/1000).toFixed(0)}k/-`} />
                <Tooltip formatter={(value) => [`₹${value.toLocaleString('en-IN')}`, 'Amount']} />
                <Legend iconType="circle" wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }} />
                <Line type="monotone" dataKey="purchaseAmount" name="Purchase Amount" stroke="#f59e0b" strokeWidth={2} dot={{ r: 4 }} />
                <Line type="monotone" dataKey="saleAmount" name="Sale Amount" stroke="#06b6d4" strokeWidth={2} dot={{ r: 4 }} />
                <Line type="monotone" dataKey="expenseAmount" name="Expense Amount" stroke="#94a3b8" strokeWidth={2} dot={{ r: 4 }} />
                <Line type="monotone" dataKey="purchasePayment" name="Purchase Payment" stroke="#ef4444" strokeWidth={2} dot={{ r: 4 }} />
                <Line type="monotone" dataKey="saleInvoicePayment" name="Sale Invoice Payment" stroke="#10b981" strokeWidth={2} dot={{ r: 4 }} />
            </LineChart>
        </ResponsiveContainer>
    </div>
);

export const FinancialMixPieChart = ({ mixData, totalMix }) => (
    <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '24px', color: '#0f172a' }}>Overall Financial Mix</h3>
        <ResponsiveContainer width="100%" height={250}>
            <PieChart>
                <Pie data={mixData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none">
                    {mixData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.fill} />)}
                </Pie>
                <Tooltip formatter={(value) => `₹${value.toLocaleString('en-IN')}`} />
                <Legend iconType="circle" wrapperStyle={{ fontSize: '12px' }} />
                <text x="50%" y="45%" textAnchor="middle" dominantBaseline="middle" style={{ fontSize: '14px', fill: '#64748b', fontWeight: '500' }}>Total</text>
                <text x="50%" y="55%" textAnchor="middle" dominantBaseline="middle" style={{ fontSize: '18px', fill: '#0f172a', fontWeight: '700' }}>₹{totalMix.toLocaleString('en-IN')}</text>
            </PieChart>
        </ResponsiveContainer>
    </div>
);

export const MonthlyBarChart = ({ chartData }) => (
    <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '24px', color: '#0f172a' }}>Monthly Overall Financial Mix Bar Chart</h3>
        <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
                <XAxis dataKey="month" tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} tickFormatter={(v) => `${(v/1000).toFixed(0)}k/-`} />
                <Tooltip formatter={(value) => [`₹${value.toLocaleString('en-IN')}`, 'Amount']} />
                <Legend iconType="square" wrapperStyle={{ fontSize: '12px', paddingBottom: '10px' }} verticalAlign="top" align="right" />
                <Bar dataKey="purchaseAmount" name="Purchase" fill="#fdb166" barSize={30} />
                <Bar dataKey="saleAmount" name="Sale" fill="#4ade80" barSize={30} />
                <Bar dataKey="expenseAmount" name="Expense" fill="#f87171" barSize={30} />
            </BarChart>
        </ResponsiveContainer>
    </div>
);
